import React, { useRef, useState, useEffect } from "react";
import { m } from "framer-motion";
import useOnClickOutside from "@/utils/use-click-outside";
import { useForm } from "react-hook-form";
import MailchimpSubscribe from "react-mailchimp-subscribe";
const SubscribeForm = ({ status, message, onValidated }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = useForm();
  const [active, setActive] = useState(false);
  const ref = useRef(null);
  useOnClickOutside(ref, () => setActive(false));
  useEffect(() => {
    if (status === "success") clearFields();
  }, [status]);
  const clearFields = () => {
    reset();
  };
  function onSubmit(data) {
    // data.email &&
    //   data.name &&
    //   data.email.indexOf("@") > -1 &&
    //   onValidated({
    //     MERGE0: data.email,
    //     MERGE1: data.name,
    //     MERGE2: data.message,
    //   });
  }
  return (
    <form
      className="flex w-full items-center justify-center"
      onSubmit={handleSubmit(onSubmit)}
      noValidate
    >
      {status === "error" && (
        <div
          className="text-center text-red text-sm w-full"
          dangerouslySetInnerHTML={{ __html: message }}
        />
      )}

      {status === "success" && (
        <div
          className="text-center text-darkGrey text-sm w-fit border-dashed border-[1px] border-darkGrey rounded md:p-8 min-w-[500px] px-4 py-8 md:text-base font-medium"
          dangerouslySetInnerHTML={{
            __html: "Thank you for reaching out!",
          }}
        />
      )}
      {status !== "success" && status !== "error" && (
        <div className="flex flex-col w-full items-center justify-center">
          <div
            ref={ref}
            className="rounded-full overflow-hidden flex items-center justify-start relative bg-[#E9E7DE] border-[1px] px-4 h-[47px] border-[#dddad0] md:w-[506px] w-[90%]"
          >
            <input
              {...register("email", {
                required: `${"Please provide your email address"}`,
                pattern: {
                  value:
                    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                  message: "Please provide a valid email address",
                },
              })}
              onClick={() => setActive(true)}
              type="email"
              placeholder="Subscribe to Newsletter |  Type in your email"
              className={`ring-0 outline-none bg-inherit decoration-none ${
                !active ? "w-full" : "w-[calc(100%-100px)]"
              } text-sm text-darkGrey placeholder:text-[#242424]/40 text-center font-light placeholder:font-light transition-all duration-500 ease`}
            />

            <m.button
              initial={{ opacity: 0, y: "100%" }}
              animate={{ opacity: active ? 100 : 0, y: active ? 0 : "100%" }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
              type="submit"
              className="absolute top-[4px] right-[4px] cursor-pointer hover:bg-darkGrey hover:text-white text-sm bg-[#D5D1C1] text-darkGrey font-light rounded-full px-4 h-[37px] items-center justify-center flex w-[100px]"
            >
              Subscribe
            </m.button>
          </div>
          {errors?.email?.message && (
            <p className="text-sm text-red-500 text-center">
              {errors?.email?.message}
            </p>
          )}
        </div>
      )}
    </form>
  );
};
const Subscribe = (props) => {
  // const url = `https://tarasha.us17.list-manage.com/subscribe/post?u=86262d788b7786c481fbd4c8e&id=5d12a1ddbf`;

  return (
    <div className="w-full z-[1]">
      <MailchimpSubscribe
        //   url={url}
          url={""}
        render={({ subscribe, status, message }) => (
          <SubscribeForm
            status={status}
            message={message}
            onValidated={(formData) => subscribe(formData)}
          />
        )}
      />
    </div>
  );
};

export default Subscribe;
